import { render, staticRenderFns } from "./StudentCreate.vue?vue&type=template&id=8d5993ea"
import script from "./StudentCreate.vue?vue&type=script&lang=ts"
export * from "./StudentCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports